export default __webpack_public_path__ + "i18n/translations/translation-zh.d243ddaf.json";